import plugin from '../src/index.js'

export default plugin
